import type { ProgressBarLevel } from "@revmatics/catalyst";
import { getPasswordStrength } from "./getPasswordStrength.ts";

export const domainRegex = /\.[a-z]{2,}(?:\.[a-z]{2,})?(?=\/|$)/i;

export const hasValidDomain = (url: string) => {
  return domainRegex.test(url);
};

export const isValidUrl = (url: string) => {
  let isValid: boolean;
  try {
    const urlObject = new URL(url);
    isValid = ["http:", "https:"].includes(urlObject.protocol);
  } catch {
    isValid = false;
  }
  return isValid;
};

export const isPasswordValid = (value: string) => {
  const password = value || "";
  const hasLower = /[a-z]/.test(password);
  const hasUpper = /[A-Z]/.test(password);
  const hasDigit = /[0-9]/.test(password);
  const hasSpecial = /[^A-Za-z0-9]/.test(password);
  const minLength = password.length >= 8;

  if (!minLength) {
    return "Password must be at least 8 characters long.";
  }
  if (!hasLower) {
    return "Password must include at least one lowercase letter.";
  }
  if (!hasUpper) {
    return "Password must include at least one uppercase letter.";
  }
  if (!hasDigit) {
    return "Password must include at least one number.";
  }
  if (!hasSpecial) {
    return "Password must include at least one special character (e.g., !@#$%).";
  }
  const level: ProgressBarLevel = getPasswordStrength(password);
  if (level < 3) {
    return "Password is not strong enough. Use letters of different case, numbers, and at least one special character.";
  }

  return true;
};
